import { JSX } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

interface C42JWPlayerProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: C42JWPlayerProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;

  return (
    <div className={`component ${props?.params?.styles}`} id={id ? id : undefined}>
      <div className="component-content">
        <p>C42JWPlayer Component</p>
      </div>
    </div>
  );
};
